import { ScheduleItemV2 } from '@hopin-team/api-hopin';

import { ItemWithTimeStatus } from './getItemsWithTimeStatus';

export const hasTimeStatus = (
  item: ItemWithTimeStatus | ScheduleItemV2,
): item is ItemWithTimeStatus =>
  (item as ItemWithTimeStatus).timeStatus !== undefined;
